function consoleLog($message, $bg, $color) {
	console.log('%c' + $message, 'background-color:' + $bg + '; color:' + $color + ';padding:3px 5px;');
}

function MadeByMcube() {
	consoleLog('Fabriqué à Lyon par Mcube', '#FA3348', '#ffffff');
	consoleLog('www.mcube.fr');
}

function mcubeDebug() {
	devMode = localStorage.getItem('devMode');
	if(devMode === 'true'){
		document.body.classList.add('debug-mode');
	}
}
